export function openUrl(url: string, target: string = '_blank') {
    const a = document.createElement("a");
    a.href = url;
    a.target = target;
    document.body.appendChild(a);
    a.click();
    a.remove();
}